import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { shouldTrackPath, trackPageView } from "../../analytics/posthog";

/** Sends SPA page views to PostHog on route changes. */
export default function PostHogPageView() {
  const location = useLocation();

  useEffect(() => {
    if (!shouldTrackPath(location.pathname)) return;
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
